import React from "react";
import QuizOptions from "../shared/QuizOptions";
import QuizTitle from "../shared/QuizTitle";
import QuizOption from "../shared/QuizOption";
import QuizContent from "../shared/QuizContent";
import { getQuizOptions } from "../../utils/quizOptions";

const Step1 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("age");

  const handleOptionClick = (value) => {
    onAnswer("age", value);
  };

  return (
    <div className="quizContentWrapper">
      <QuizContent>
        <QuizTitle>How old are you?</QuizTitle>
        <QuizOptions>
          {quizOptions.map((option) => (
            <QuizOption
              key={option.value}
              value={option.value}
              name="age"
              onClick={handleOptionClick}
            >
              <div>
                <p>
                  <strong>{option.text}</strong>
                </p>
              </div>
            </QuizOption>
          ))}
        </QuizOptions>
      </QuizContent>
    </div>
  );
};

export default Step1;
